<template>
  <transition name="slide-fade">
    <v-container fluid>
      <v-layout wrap class="justify-center">
        <v-flex xs12 sm11 md10>
          <h3 class="text-center">Service Requests</h3>
          <v-card>
            <v-card-title class="py-1">
              <inertia-link href="/service_request_confirmations">Confirmations</inertia-link>
              <v-spacer></v-spacer>
              <v-text-field label="Search" v-model="filterBy" prepend-inner-icon="mdi-card-search-outline"></v-text-field>
            </v-card-title>
            <v-card-text>
              <service-requests-index :service_requests="service_requests" :filterBy="filterBy"></service-requests-index>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </transition>
</template>

<script>
  import layout from '@/Layouts/MainLayout'
  const ServiceRequestsIndex = async () => await import( /* webpackMode: 'lazy' */ /* webpackChunkName: "service-requests" */ '@/Components/ServiceRequest/index')

  export default {
    name: 'ServiceRequests',
    layout,
    props: [
      'service_requests',
    ],
    components: {
      ServiceRequestsIndex
    },
    metaInfo () {
      return {
        title: 'Service Requests',
        titleTemplate: '%s | ' + this.$title,
      }
    },
    data () {
      return {
        filterBy: ''
      }
    },
  }
</script>
